module.exports = __webpack_public_path__ + "img/pdi1.433cd1af.svg";